import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '../../../finance/expenses/travelrefund/mixins/ExpenseMixin.js'
import InfoModalTravel from '../InfoModalTravel/InfoModalTravel.vue'
import ModalConfimarSemAdiantamento from '../ModalConfimarSemAdiantamento/ModalConfimarSemAdiantamento.vue'
import PredictionModal from '../PredictionModal/PredictionModal.vue'
import TravelAirPlaneModal from '../TravelAirPlaneModal/TravelAirPlaneModal.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import TermTravekModal from '../TermTravekModal/TermTravekModal.vue'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import ForecastTermRepository from '@/shared/http/repositories/business/forecastterm.js'
import SingModal from '../SingModal/SingModal.vue'
import Tools from '@/components/tools/Tools.js'
import formData from '../InfoModalTravel/form-modal'
import { loading, toast } from '@/shared/utils/UIHelper.js'

export default {
  name: 'ModaAddTravelAdvance',
  mixins: [ExpenseMixin, ActionsForm],
  components: {AutocompleteZ, InfoModalTravel, PredictionModal, TermTravekModal, SingModal, TravelAirPlaneModal, ModalConfimarSemAdiantamento},
  data () {
    return {
      step: 0,
      motivoViagemId: null,
      temQuantidade: false,
      semAdiantamentos: false,
      ArrayFuncionarioImpossibilitado: [],
      dataForm: formData(),
      total: 0.0,
      formFirst: {},
      personFirst: [],
      file: [],
      AnexoBaixada: [],
      statusOk: false,
      passFly: false,
      objClone: null,
      modalConfimarSemAdiantamento: false,
      dataPrevisao: null,
      objFirsForm: null,
      dataHistory: {
        objFirsForm: [],
        objSecondForm: null,
        objThirdForm: null
      }
    }
  },
  props: {
    SemAdiantamento: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    step (newvalue) {
      if (newvalue === 0) this.passFly = false
      if (newvalue === 2) {

      }
    }
  },
  computed: {
    widthPogress: function () {
      let teste = 4
      if (this.step === 0) return '0'
      let quantStep = this.passFly === false ? this.step - 1 : this.step
      teste = this.passFly === false ? teste - 1 : teste
      let total = (quantStep * 100) / (teste)
      return total
    }
  },
  methods: {
    quantidadeVazio (value) {
      this.temQuantidade = value
    },
    SemAdiantamentoVerifica (valeu) {
      if (valeu != null) {
        this.semAdiantamentos = valeu
      }
    },
    show () {
      this.$refs['add-travel-modal'].show()
    },
    backStep (nextStep) {
      if (nextStep === 1 && !this.passFly) nextStep--
      if (this.step > nextStep) this.step = nextStep
    },
    close () {
      this.step = 0
      this.passFly = false
      if (window.localStorage.key('formFirst')) {
        window.localStorage.removeItem('formFirst')
      }
      this.formFirst = {}
      this.objClone = null
      if (Object.keys(this.formFirst).length > 0) {
        this.formFirst.termoPrevisaos.value = []
      }
      this.$refs['add-travel-modal'].hide()
    },
    voltarConfirma () {
      this.step = 0
      this.modalConfimarSemAdiantamento = !this.modalConfimarSemAdiantamento
    },
    nextStep (noneSing = false) {
      if (this.step === 4) {
        this.file = this.$refs.SingModal.file
        this.createTerm()
      }
      if (this.step === 3) {
        this.AnexoBaixada = this.$refs.TermTravekModal.file
        this.validaFormThird()
      }
      if (this.step === 2) {
        this.$refs.PredictionModal.verificaQuantidade()
        this.validaFormSecond()
        this.$refs.PredictionModal.formData = this.formFirst.termoPrevisaos.value
      }
      if (this.step === 1) {
        this.validaFormSecondAir()
        this.addFormAir(this.$refs.TravelAirPlaneModal.form)
      }
      if (this.step === 0) {
        this.motivoViagemId = this.formFirst = this.$refs.InfoModalTravel.form.motivoViagemId.value
        this.validaFormFirt()
      }
      if (this.step < 4) {
        this.step++
      }
    },
    eventAir () {
      if (this.objClone !== null) {
        this.$refs.TravelAirPlaneModal.onLoadClone(this.objClone)
      }
    },
    validaFormSecondAir () {
      if (!this.validarObject(this.$refs.TravelAirPlaneModal.form)) {
        toast.error('Algumns campos não foram preenchido')
        throw new Error()
      }
    },
    onLoadThird () {
      if (this.dataForm.termoPrevisaos.value !== null) {
        this.$refs.PredictionModal.clone(this.dataForm.termoPrevisaos.value)
      }
    },
    onLoad () {
      if (Object.keys(this.formFirst).length > 0) {
        this.$refs.InfoModalTravel.backInfo()
      } else {
        if (this.objClone !== null) {
          this.$refs.InfoModalTravel.clone(this.objClone)
        }
      }
    },
    getDespesasitens () {
      loading.push()
      ForecastTermRepository.GetAllByTermo(this.objClone.id)
        .then(Response => {
          this.dataPrevisao = Response.data.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    addFormAir (obj) {
      Object.keys(obj).forEach((Element) => {
        this.formFirst[Element].value = obj[Element].value
      })
    },
    fortmDataobj (data = {}) {
      let dataFinal = {}
      Object.keys(data).forEach((Element) => {
        dataFinal[Element] = data[Element].value
      })
      return dataFinal
    },
    validaFormThird () {
      if (!this.$refs.TermTravekModal.checked) {
        toast.error('O Termo não foi aceito')
        throw new Error()
      }
    },
    validedFormFor () {
      if (!this.$refs.SingModal.hasFile) {
        toast.error('Necessario a Assinatura para proseguir!!')
        throw new Error()
      } else {
      }
    },
    validaFormSecond () {
      let despesaItem = this.$refs.PredictionModal.formData
      let verificarDespesaNull = despesaItem.find((Element) => Element.despesa === null)
      if (verificarDespesaNull !== undefined || this.temQuantidade === true) {
        toast.error('O Termo Possui itens ainda não finalizado')
        throw new Error()
      }
      this.formFirst.termoPrevisaos.value = despesaItem
      this.total = this.$refs.PredictionModal.total
      let valorSolicitado = parseFloat(this.total.replace('R$', '').replace('.', '').replace(',', '.'))
      this.formFirst.valorSolicitado.value = valorSolicitado
    },
    validaFormFirt () {
      this.personFirst = this.$refs.InfoModalTravel.person
      this.formFirst = this.$refs.InfoModalTravel.form
      this.objFirsForm = {...this.formFirst}
      window.localStorage.setItem('formFirst', JSON.stringify(this.$refs.InfoModalTravel.form))
      this.dataHistory.objFirsForm.push(this.$refs.InfoModalTravel.form)
      if (!this.validarObject(this.formFirst)) {
        toast.error('Algumns campos não foram preenchido')
        throw new Error()
      }
      if (this.formFirst.semAdiantamento.value) {
        this.modalConfimarSemAdiantamento = true
      } else {
        if (this.formFirst.passagem.value === false || this.formFirst.passagem.value === null) {
          this.step++
        } else {
          this.passFly = true
        }
      }
    },
    clone (obj) {
      this.objClone = obj
    },
    createTerm () {
      loading.push()
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      let termoaceite = this.fortmDataobj(this.formFirst)
      if (this.passFly) {
        termoaceite['possuiVoo'] = true
      }
      let json = JSON.stringify(termoaceite)
      data.append('json', json)
      data.append('file', this.file)
      data.append('AnexoBaixada', this.AnexoBaixada)
      AcceptanceTermRepository.SaveTermoAceite(this.CompanySelected, data, conf)
        .then(Response => {
          this.close()
          loading.pop()
          this.modalConfimarSemAdiantamento = false
          this.$emit('success')
        })
        .catch(Error => {
          toast.error(Error.response.data)
          this.modalConfimarSemAdiantamento = false
          let funcionarioid = this.formFirst.funcionarioId.value
          let motivoViagemid = this.formFirst.motivoViagemId.value
          let dataInicio = this.formFirst.dataInicio.value
          let dataFimviagem = this.formFirst.dataFim.value
          this.GetFuncionariosImpossibilitados({MotivoViagemId: motivoViagemid, FuncionarioId: funcionarioid, EmpresaId: this.CompanySelected, DataInicio: dataInicio, DataFim: dataFimviagem, DespesaViagem: false})
          this.$refs['add-travel-modal'].hide()
          loading.pop()
        })
    },
    GetFuncionariosImpossibilitados (data) {
      loading.push()
      this.$refs['add-travel-modal-erro'].show()
      AcceptanceTermRepository.FuncionarioImpossibilitado(data)
        .then(Response => {
          this.ArrayFuncionarioImpossibilitado = Response.data
          if (this.ArrayFuncionarioImpossibilitado.despesasViagem.length === 0) {
            this.ArrayFuncionarioImpossibilitado.despesasViagem = null
          }

          if (this.ArrayFuncionarioImpossibilitado.despesasDiversos.length === 0) {
            this.ArrayFuncionarioImpossibilitado.despesasDiversos = null
          }

          if (this.ArrayFuncionarioImpossibilitado.termoAceite.length === 0) {
            this.ArrayFuncionarioImpossibilitado.termoAceite = null
          }

          if (this.ArrayFuncionarioImpossibilitado.despesa.length === 0) {
            this.ArrayFuncionarioImpossibilitado.despesa = null
          }

          if (this.ArrayFuncionarioImpossibilitado.motivoDesligado.length === 0) {
            this.ArrayFuncionarioImpossibilitado.motivoDesligado = null
          }

          if (this.ArrayFuncionarioImpossibilitado.adiantamentoIdentico.length === 0) {
            this.ArrayFuncionarioImpossibilitado.adiantamentoIdentico = null
          }

          this.close()
          loading.pop()
        })
        .catch(Error => {
          toast.error(Error.response.data)
          loading.pop()
        })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    validarObject (obj) {
      let valida = true
      if (obj.paisOrigemPreSelecionaoID.value != null) {
        obj.paisOrigemID.value = obj.paisOrigemPreSelecionaoID.value
        obj.paisDestinoID.value = obj.paisDestinoPreSelecionadoID.value
      }
      Object.keys(obj).forEach((Element) => {
        if (obj[Element]['required'] === true) {
          if (obj[Element]['value'] === null) {
            valida = false
          }
        }
      })
      return valida
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/ModaAddTravelAdvance/ModaAddTravelAdvance.js